export default function Blog() {
  return (
    <section id="blog" className="px-5 py-12">
      <div className="flex justify-between items-start gap-12">
        <h2 className="md:text-4xl text-2xl mt-2">
            From the <span className="text-[#D07728]">Blog</span>
        </h2>
        <button onClick={() => window.location.href = "https://substack.com/@harveykwiyani"} className="bg-[#D07728] px-4 py-2 text-xs md:text-sm lg:text-base">ALL POSTS ON SUBSTACK</button>
      </div>
        
        <div className="space-y-6 mt-4">
          <a href="https://open.substack.com/pub/harveykwiyani/p/135-decolonizing-mission-recognised?r=18k6nw&utm_campaign=post&utm_medium=web"><div className="p-6 rounded-xl bg-[#Fcfbfa] md:w-2/3 w-full">
            <h3 className="text-sm font-medium text-[#D07728]">FEATURED ESSAY</h3>
            <h3 className="mt-2 md:text-2xl text-1xl">
              Decolonizing Mission Recognised
            </h3>
            <p className="text-gray-600 mt-3 mb-3 flex items-start gap-2 md:text-lg">
              Decolonizing Mission has been named among the Ten Outstanding Books in Mission Studies, World Christianity, and Intercultural Theology for 2025 by the International Bulletin of Mission Research.
            </p>
              <h3 className="text-sm font-medium text-[#D07728]">READ MORE <span className="text-[#D07728]">↗</span></h3>
          </div></a>
          <a href="https://harveykwiyani.substack.com/p/150-what-is-mission-without-paternalism?r=18k6nw&utm_campaign=post&utm_medium=web"><div className="mt-4 p-6 rounded-xl bg-[#Fcfbfa] md:w-2/3 w-full">
            <h3 className="text-sm font-medium text-[#D07728]">RECENT . OCTOBER 2026</h3>
            <h3 className="mt-2 md:text-2xl text-1xl">
              What Is Mission Without Paternalism?
            </h3>
            <p className="text-gray-600 mt-3 mb-3 flex items-start gap-2 md:text-lg">

Imagining New Models for Mission            </p>
              <h3 className="text-sm font-medium text-[#D07728]">READ MORE <span className="text-[#D07728]">↗</span></h3>
          </div></a>
          
        </div>
      </section>
  );
}